// extracted by mini-css-extract-plugin
module.exports = {"button":"SecondaryButton--button--1VPfE","default":"SecondaryButton--default--3Gw76","light":"SecondaryButton--light--1zbXk"};